export default "__VITE_ASSET__xqdYb$9X__"